const PROD_REGION_URLS: Record<Region, string> = {
  AU: import.meta.env.VITE_API_BASE_URL,
  US: import.meta.env.VITE_API_URL_US,
  EU: import.meta.env.VITE_API_URL_EU
};

export type Region = "AU" | "US" | "EU";

export const REGIONS: { code: Region; label: string }[] = [
  { code: "AU", label: "Australia" }
  // TODO: https://asiga.atlassian.net/browse/MESH-1021 - Re-enable cross-region support when policies are updated.
  // { code: "US", label: "North America" },
  // { code: "EU", label: "Europe" }
];

/**
 * Returns the API base URL based on the current environment and region.
 *
 * - In non-production environments, returns the default API base URL from environment variables or "/" if not set.
 * - In production, returns the region-specific API base URL from `PROD_REGION_URLS`, defaulting to "AU" if no region is provided.
 *
 * @param region - Optional region identifier used to select the production API base URL.
 * @returns The resolved API base URL as a string.
 */
export const getApiBaseUrl = (region?: Region): string => {
  const defaultUrl = import.meta.env.VITE_API_BASE_URL ?? "/";

  if (import.meta.env.VITE_SENTRY_ENVIRONMENT !== "prod") {
    return defaultUrl;
  }

  return PROD_REGION_URLS[region ?? "AU"];
};

/**
 * Retrieves all unique API domain URLs used by the application.
 *
 * This function collects the default API base URL from environment variables
 * and combines it with all production region URLs defined in `PROD_REGION_URLS`.
 * It returns a deduplicated array of these domain URLs.
 *
 * @returns {string[]} An array of unique API domain URLs.
 */
export const getAllApiDomains = (): string[] => {
  const defaultUrl = import.meta.env.VITE_API_BASE_URL;
  const domains = new Set([defaultUrl, ...Object.values(PROD_REGION_URLS)]);
  return [...domains];
};
